import React, { useEffect, useState } from 'react';
import {Button, Card} from "antd";
import {LockOutlined} from "@ant-design/icons";
import { getAttachment } from 'utils/attachment';
import { addToCart, getQuantity, isItemExistsInCart, subtractItem } from 'utils/cart';
import { useDispatch, useSelector } from 'react-redux';
import { changeQuantity } from 'redux/actions';
import { isAddonRequired } from 'utils/addons';

const {Meta} = Card;

function SliderProduct({product, locale}) {

    const [quantity, setQuantity] = useState(0)
    const {cartData: {cartQuantity}, fetchedData: {storeData}} = useSelector(state => state)
    const dispatch = useDispatch()

    const amount = product?.promotions?.[0]?.amount;
    const discountType = product?.promotions?.[0]?.discountType;

    const addItemToCart = (e) => {
        if (product?.stock && !isAddonRequired(product?.productAddons)) {
            e.preventDefault();
                if (product?.stock > quantity) {
                    addToCart({
                        ...product, 
                        chosenAddons:product?.productAddons,
                        price: discountType === 'AMOUNT' ? product.price - amount : discountType === 'PERCENTAGE' ? product.price - (product.price * (amount / 100)) : product.price
                    });
                dispatch(changeQuantity(1))
            }
        }
    }
    const subtractItemFromCart=(e)=>{
        e.preventDefault();
        subtractItem(product)
        dispatch(changeQuantity(-1))
    }

    useEffect(() => {
        setQuantity(getQuantity(product.id, product?.productAddons))
    }, [cartQuantity])

    return (
        <Card
            cover={<img 
                className={`item-menu__image ${!product?.stock && 'soldOut'}`}
                alt="example" 
                src={product?.images?.length ? getAttachment(product?.images[0].id) : '/img/productsFallback.svg'}
            />}
            className={`item-menu__product position-relative pinned-card ${!product?.stock && 'relative'}`}
        >
            {!product?.stock && <div className='soldOutText'>Sold out</div>}
            {product?.label && <div className={`item_menu_label`} style={{color: product?.label?.colorLight, backgroundColor: product?.label?.colorDark}}>
                    {locale === 'en' ? product?.label.titleEng : product?.label.titleAr}
                </div>}
            {/* {product?.stock>0 && product?.promotions?.length>0 && <div className="promo_corner_product">Discount</div>} */}
            <Meta
                className={`${!product?.stock && 'soldOut'}`}
                title={<>
                    <span className='text-black'>{(locale==='en' ? product?.nameEng : product?.nameAr).toUpperCase()}</span> <br/>
                    {product?.promotions?.[0]?.id ? 
                        <span className='promotions'>
                            { 
                              discountType === 'AMOUNT' ? <>{storeData?.currency?.name ?? "KWD"} {(amount).toFixed(3)} off</> :
                              discountType === 'PERCENTAGE' ? amount + '% off' : '' 
                            }
                        </span> : ""
                    }
                </>
                }
                description={
                    isItemExistsInCart(product?.id, product?.productAddons) ? <div className='counterContainer d-flex justify-content-center align-items-center'>
                        <img onClick={subtractItemFromCart} src='/img/minusItem.svg' alt='minus' className='changeQuantity'/>
                        <div className='mx-3 text-black font-16'>{quantity} </div>
                        <img onClick={addItemToCart} src='/img/plusItem.svg' alt='plus' className={`changeQuantity ${quantity===product?.stock && 'disabledSoldOutCounter'}`}/>
                    </div> :
                    <Button onClick={addItemToCart} className='card-button text-black w-100 px-2 '>
                        {
                            isAddonRequired(product?.productAddons) ? 'Price on selection' : 
                            <div className='d-flex align-items-center justify-content-between'>
                                <span> {storeData?.currency?.name ? storeData?.currency.name : "KWD" } {product?.price}</span>
                                <img src='/img/addToCart.svg' alt='addToCart'/>
                            </div>
                        }
                    </Button>
                }
            />
        </Card>
    );
}

export default SliderProduct;